import { render, staticRenderFns } from "./cursos_asig_docente.vue?vue&type=template&id=28b6abb7"
import script from "./cursos_asig_docente.vue?vue&type=script&lang=js"
export * from "./cursos_asig_docente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports